/** @format */

import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { MdEdit,MdDelete } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import locationServices from '../../../Services/locationServices';
import { ChangeStatus } from '../../../Components';
import Loader from '../../../Components/Loader';
import { useContextCrud } from '../../../ContextManagement/ContextManager';
import { useLocation } from 'react-router-dom'
import CheckAccess from '../../../Function/CheckAccess';
let currentPage1 = 1;

export const PortList = () => {
  const [cityList, setPortList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [pagination, setPagination] = useState({ limit: 10 });
  const [loader, setLoader] = useState(true);
  const history = useHistory();

  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  const { searchValue, setSearchValue, pageValue, setPageValue } = useContextCrud();

  useEffect(() => {
    getCountryList();
  }, []);

  useEffect(() => {
    getPortList();
  }, []);

  const getPortList = (countryId = searchValue.value, currentPage = currentPage1) => {

    let param = {
      page: currentPage,
      limit: pagination.limit,
    };

    if (countryId) {
      param['country_id'] = countryId;
    }
    setLoader(true);
    locationServices.getCity(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setPortList(res.data);
        setPagination(res.pagination);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const getCountryList = () => {
    let param = { page: 1, limit: 300 };
    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        arry.push({ value: '', label: 'All country' });
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name });
        });
        setCountryList(arry);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      city_id: isModalOpen._id,
      city_status: isModalOpen.city_status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
    };
    locationServices.updateCityStatus(postData).then((res) => {
      if (res.status) {
        setIsModalOpen(false);
        getPortList();
      }
    });
  };
  const onDeleteModalSubmit = () => {
    let postData = {
      city_id: isDeleteModalOpen._id
    };
    locationServices.deletePort(postData).then((res) => {
      if (res.status) {
        setIsDeleteModalOpen(false);
        getPortList();
      }
    });
  }

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    getPortList(searchValue?.value, e.selected + 1)
    setPageValue(e.selected + 1);
  };

  const onSelectCountry = (e) => {
    setSearchValue(e)
    getPortList(e.value, pageValue);
  };

  return (
    <div className='row'>
      <div className='col-lg-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='d-flex  mb-3 table_filter'>
              <div>
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: 'calc(2.15rem + 2px)',
                      overflowY: 'visible',
                    }),
                    control: (provider) => ({
                      ...provider,
                      width: '200px',
                      boxShadow: '0 0 0 0px #f46a6a',
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: '#a0b0ca',
                    }),
                  }}
                  placeholder='Search with country...'
                  value={searchValue}
                  onChange={(e) => onSelectCountry(e)}
                  options={countryList}
                />
              </div>
              {
                (CheckAccess(32,"add")  ||  user_type === "SUPERADMIN" ) && 

              <button
                className='btn btn-primary w-sm waves-effect waves-light'
                onClick={() => history.push('/add-port')}
              >
                Add Port
              </button>
              }
            </div>
            <div className='table-responsive'>
              <table className='table table-centered table-nowrap mb-0'>
                <thead className='table-light'>
                  <tr>
                    <th>S no.</th>
                    <th>Name</th>
                    <th>Country</th>
                    <th>Air Mode </th>
                    <th>Air Door Mode </th>
                    <th>Sea Mode </th>
                    <th>Sea Door Mode </th>
                    <th>Road Mode </th>
                    <th>courier Mode </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {cityList.length > 0 &&
                    cityList.map((item, key) => (
                      <tr key={key}>
                        <td className='text-body fw-bold'>
                          {(pageValue - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>{item.city_name}</td>
                        <td>
                          {item.country ? item.country.country_name : 'N/A'}
                        </td>
                        <td>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.air_courier_available === true
                                ? ' bg-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.air_courier_available === true ? 'Yes' : 'No'}
                          </span>
                        </td>
                        <td>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.air_door_courier_available === true
                                ? ' bg-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.air_door_courier_available === true ? 'Yes' : 'No'}
                          </span>
                        </td>
                        <td>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.sea_courier_available === true
                                ? ' bg-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.sea_courier_available === true ? 'Yes' : 'No'}
                          </span>
                        </td>
                        <td>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.sea_door_courier_available === true
                                ? ' bg-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.sea_door_courier_available === true ? 'Yes' : 'No'}
                          </span>
                        </td>
                        <td>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.road_courier_available === true
                                ? ' bg-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.road_courier_available === true
                              ? 'Yes'
                              : 'No'}
                          </span>
                        </td>
                        <td>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.courier_available === true
                                ? ' bg-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.courier_available === true ? 'Yes' : 'No'}
                          </span>
                        </td>

                        <td>
                          <span
                            className={
                              'badge rounded-pill font-size-12 pointer' +
                              (item.city_status === 'ACTIVE'
                                ? ' bg-success'
                                : ' bg-soft-danger')
                            }
                            onClick={() => setIsModalOpen(item)}
                          >
                            {item.city_status}
                          </span>
                        </td>
                        <td>
                        {
                           (CheckAccess(32,"edit") || user_type === "SUPERADMIN") && 

                          <MdEdit
                            className='pointer'
                            onClick={() => {
                              // Storage.set('pageNum', pagination.page);
                              history.push('edit-port?id=' + item._id);
                            }}
                            color='#0323fe'
                            size='25px'
                          />
                        }
                        {
                          (CheckAccess(32,"delete") ||  user_type === "SUPERADMIN") && 

                           <MdDelete   className="pointer"
                                color="red"
                                onClick={() => setIsDeleteModalOpen(item)}
                                size="25px"></MdDelete>
                        }
                        </td>
                       
                      </tr>
                    ))}
                </tbody>
              </table>
              {cityList.length <= 0 && !loader && (
                <div className='text-center w-100 bg-warning my-5'>
                  <h6 className='py-2'> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {cityList.length > 0 && pagination.totalRecord > pagination.limit && (
            <ReactPaginate
              previousLabel={
                <img src='assets/images/prev.svg' height={15} alt='not found' />
              }
              forcePage={pageValue - 1}
              nextLabel={
                <img src='assets/images/next.svg' height={15} alt='not found' />
              }
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={(e) => onPageChangeEvent(e)}
              containerClassName={'pagination'}
              activeClassName={'active'}
            />
          )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title='Port Status'
            message={`Are you sure want to ${isModalOpen.city_status === 'ACTIVE' ? 'Inactive' : 'Active'
              } to ${isModalOpen.city_name}?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
        {Boolean(isDeleteModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isDeleteModalOpen)}
            title='Remove Port'
            message={`Are you sure want to remove ${isDeleteModalOpen.city_name} Port ?`}
            onSubmitEvent={() => onDeleteModalSubmit()}
            handleClose={() => setIsDeleteModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
